import { Schema } from "@comparaonline/products-schema";
import merge from "deepmerge";

import { useAppContext } from "../../../../../lib/appContext";
import { useFlagProps } from "../../../helpers/useFlagProps";
import { useResultsProps } from "../ResultList";
import { useCTAProps } from "./useCTAProps";
import { useDetailLink } from "./useDetailLink";
import { useFeaturedProps } from "./useFeaturedProps";
import { useRatingProps } from "./useRatingProps";

const getBadgeProps = (attributes: Schema.ProductListProduct["featuredAttributes"]) => {
  const productAttribute = attributes && attributes.find(attr => Boolean(attr && attr.descriptor));

  return productAttribute
    ? {
        color: productAttribute.value.color,
        description: productAttribute.extraDescription,
        label: productAttribute.value.value
      }
    : null;
};

export const useProductsProps = () => {
  const { isMobile } = useAppContext();
  const getResultsProps = useResultsProps();
  const getCTAProps = useCTAProps();
  const getDetailLink = useDetailLink();
  const getFeaturedProps = useFeaturedProps();
  const getFlagProps = useFlagProps();
  const getRatingProps = useRatingProps();

  return (productData: Schema.ProductListProduct) => {
    const attributes: Schema.ProductListProduct["featuredAttributes"] =
      productData.featuredAttributes || [];
    let listAttributes = attributes
      ? attributes.slice(1).filter(attr => Boolean(attr && attr.featured))
      : [];

    if (isMobile) {
      listAttributes = listAttributes.map(attr => {
        if (attr) {
          delete attr.extraDescription;
          delete attr.entity.extraDescription;
        }
        return attr;
      });
    }

    return merge(getResultsProps(productData), {
      badgeProps: getBadgeProps(attributes),
      ctaProps: getCTAProps(productData),
      featuredProps: getFeaturedProps(productData),
      flagProps: getFlagProps(productData),
      listAttributes,
      viewDetailsProps: {
        component: getDetailLink(productData)
      },
      ratingProps: getRatingProps(productData)
    });
  };
};
